module.exports = __webpack_public_path__ + "static/media/email.7f2cfdd3.svg";